export function createWorkspaceErrorMessage(error) {
  if (error?.code === 'duplicate_name') return error.message
  if (error?.code === 'cap_reached') return error.message
  const detail = error?.response?.data?.detail
  if (typeof detail === 'string') return detail
  if (detail?.code === 'workspace_required') return 'Choose a workspace before continuing.'
  if (error?.response?.status === 404) {
    return 'Workspace API is unavailable. Point the app at a local DO Chat API and restart it.'
  }
  if (error?.response?.status === 401) return 'Sign in again, then retry creating your workspace.'
  return 'Could not create workspace. Check your API connection and try again.'
}
